//دیتای پیش فرض برای فرستادن
const initialSendData = {
  id: "",
  mode: "add",
  date: "",
  // factorType: "", // پیش فاکتور یا  فاکتور factor || draft
  paymentType: "bank", //  نقد و بانک  - حساب دفتری bank || debt || cash
  paidPrice: "",
  discount: "0",
  bankId:'',
  customerId: "",
  fund:'',
  currentSelectedCustomerName: "انتخاب مشتری",
  currentSelectedBankAccountName: "انتخاب بانک",
  currentSelectCashName: "انتخاب صندوق",
  productsTableData: [],
  servicesTableData: [],
  description: "",
  sumOfProductsAndServices: 0, //جمع کالا و خدمات
  sumTotalInvoice: 0, //جمع کل فاکتور
  invoiceBalance: 0, //مانده فاکتور
  tax: 0,

};

//دیتای اولیه که از بک میاد
const initialData = {
  tax: 0,
  bankRLookUpId: 19,
  customerRLookUpId: 17,
  fundRLookUpId: 18,
  fund: { id: "25", name: "صندوق شهپوری" },
  products:[],
  services:[],
};

const componentData = {
 sumProductTotalInvoice:0,
 sumServiceTotalInvoice:0,
 reload:"",
 reloadTableData:''
}

const CounterFactorData = {
  initialSendData,
  initialData,
  componentData
};

export default CounterFactorData;
